import type { CornerRadius, EmailFontFamily, Padding } from "./types";

export const DEFAULT_FONT: EmailFontFamily = 'Arial, Helvetica, sans-serif';

export function uid(): string {
  return crypto.randomUUID();
}

export const ZERO_PADDING: Padding = { top: 0, right: 0, bottom: 0, left: 0 };

export const BLOCK_PADDING: Padding = { top: 8, right: 0, bottom: 8, left: 0 };

export const ZERO_RADIUS: CornerRadius = {
  topLeft: 0,
  topRight: 0,
  bottomRight: 0,
  bottomLeft: 0,
};
